import React from "react";
import { FluentProvider } from "@fluentui/react-components";
import { westComTheme } from "../theme/westComTheme";
import { AuthGate } from "./components/AuthGate";
import { ContactPanel } from "./components/ContactPanel";

const App: React.FC = () => {
  return (
    <FluentProvider theme={westComTheme}>
      <AuthGate>
        <ContactPanel />
      </AuthGate>
    </FluentProvider>
  );
};

export default App;
